<template>
  	<div class="stores">
    	<div class="breadcrumb">训练营 > 训练营打卡</div>
    	<div class="searchBtn">
      	<div class="search_item">
        	<div>手机号</div>
        	<input type="text" placeholder="请输入手机号" class="el-input__inner" v-model="mobile" @keyup.enter="search_mine()"/>
      	</div>
      	<div class="search_item">
        	<el-select v-model="groupId" placeholder="请选择组别"  @change="rulegroup">
          		<el-option label="请选择" value="0"></el-option>
          		<el-option v-for="gitem in groupList" :key="gitem.id" :label="gitem.groupName" :value="gitem.id"></el-option>
        	</el-select>
      	</div>
      	<div class="search_item">
	      	<el-date-picker
		      	v-model="attendanceDate"
		      	type="date"
		      	value-format="timestamp"
		      	placeholder="选择日期">
		    </el-date-picker>
		</div>
      <el-button type="primary" @click="search_mine()">搜索</el-button>
    </div>
    <div class="main">
      <template>
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="学员号"></el-table-column>
          <!-- <el-table-column prop="userName" label="名称"></el-table-column>
          <el-table-column prop="null" label="unionid"></el-table-column> -->
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="sportsDuration" label="运动时间（分钟）" :formatter="this.getDataFormat"></el-table-column>
          <el-table-column prop="weightAttendanceCount" label="体重打卡"></el-table-column>
          <el-table-column prop="dietAttendanceCount" label="饮食打卡"></el-table-column>
          <el-table-column prop="groupName" label="组别"></el-table-column>
        </el-table>
      </template>
      <div class="block" style="padding:30px 10px; float:right">
        <el-pagination
          @current-change="handleCurrentChangePage"
          :current-page="pageNum"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalPage"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    mounted() {
      this.initial();
    },
    data() {
      return {
        headers: {
          xqiao_token: localStorage.getItem("token")
        },
        courseName: '',
        mobile: '',
        userName: '',
        attendanceDate:'',
        tableData: [],
        pageNum: 1,
        limit: 10,
        totalPage: 10,
        multipleSelection: [],
        dialogVisible: false,
        groupList: [],
        groupId: null
      };
    },
    methods: {
      //初始化表格数据
      initial() {
        this.getPage()
        this.$get("/offlineTrainingCamp/group/list")//获取所有组名"
          .then(res => {
            if (res.code == 0) {
              this.groupList = res.data;
            }
          })
          .catch(() => {
          });
      },
      getPage() {
        var params = {
          pageNum: this.pageNum,
          limit: this.limit,
          groupId: this.groupId,
          mobile: this.mobile,
          attendanceDate:this.attendanceDate
          // userName: this.userName
        };
        this.$get("/offlineTrainingCamp/attendance/list", params)///trainingCamp/getList
          .then(res => {
            if (res.code == 0) {
              this.tableData = res.data.list;
              this.totalPage = res.data.total;
            } else {
              this.$message({
                message: res.message,
                type: "warning"
              });
              return false;
            }
          })
          .catch(() => {
            console.log();
          });
      },
      //当前页数
      handleCurrentChangePage(val) {
        this.pageNum = val;
        this.getPage();
      },
      search_mine() {
        this.getPage();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
      },
      rulegroup(val) {
        console.log("cons", val);
        this.groupId = val
      },
      getDataFormat: function (row, column) {
        let val = row[column.property];
        if (!val || isNaN(val)) {
          val = 0
        }
        return this.global.formatSecond(val);
      }
    },
    filters: {}
  };
</script>

<style scoped>
  .searchBtn{
    display:flex
  }

  .search_item{
    display:flex;
    font-size:13px;
    align-items:center;
    margin-right:20px
  }

  .search_item div{
    margin-right:10px;
  }

  .search_item input{
    flex:1
  }

</style>



// WEBPACK FOOTER //
// src/views/trainingCamp/campClock.vue